<template>
  <z-dialogo ref="dialogo" :titulo="titulo" :dividers="true" largura="500px" persistent>
    <template #texto>
      <v-row dense>
        <v-col cols="12" sm="6">
          <z-date-picker-menu v-model="filtro.data_inicial" label="Data Inicial" filled dense></z-date-picker-menu>
        </v-col>
        <v-col cols="12" sm="6">
          <z-date-picker-menu v-model="filtro.data_final" label="Data Inicial" filled dense></z-date-picker-menu>
        </v-col>
      </v-row>
    </template>

    <template #actions_right>
      <v-btn text @click="$refs.dialogo.fechar()">
        Cancelar
      </v-btn>
      <v-btn text color="primary" @click="imprimir">
        <v-icon left>mdi-printer</v-icon>
        Imprimir
      </v-btn>
    </template>
  </z-dialogo>
</template>

<script>
// import { MESES } from '@/app/globals';

export default {
  name: 'zDialogoIntervaloData',

  props: {
    titulo: {
      type: String,
      default: '',
    },

    relatorio: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      aberto: false,
      filtro: {
        data_inicial: this.$dayjs().format('YYYY-MM-DD'),
        data_final: this.$dayjs().format('YYYY-MM-DD'),
      },
      meses: this.$globals.MESES,
    };
  },

  mounted () {
    this.filtro.data_inicial = this.$dayjs().startOf("month").format('YYYY-MM-DD');
    this.filtro.data_final = this.$dayjs().endOf("month").format('YYYY-MM-DD');
  },

  methods: {
    abrir() {
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    imprimir() {
      this.$emit('imprimir', this.filtro);
    },
  },
};
</script>

<style scoped></style>
